import { useState, useEffect } from "react";
import PageTitle from "./../../../components/common/pageTitle/PageTitle";
import { useNavigate } from "react-router-dom";
import { setWeddingType } from "@src/@slice/recommendHallSlice";
import { useRecommendHall } from "./../../../utils/hooks/useRecommendHall";
import CustomHeader from "@src/components/common/appHeader/CustomHeader";

import ImageSelectableCard from "@src/components/recommend/ImageSelectableCard";

import separate from "@assets/images/recommend/weddinghall/seremony_separate.jpg";
import simultaneous from "@assets/images/recommend/weddinghall/seremony_simultaneous.jpg";

import StopRecommend from "./_component/StopRecommend";

const hallTypes = [
  { title: "분리", subTitle: "예식과 피로연 공간이 분리", src: separate },
  { title: "동시", subTitle: "피로연장 이동없이 식사진행", src: simultaneous },
];

const Type = () => {
  const navigate = useNavigate();
  const [validate, setValidate] = useState(false);
  const [showStopModal, setShowStopModal] = useState(false);
  const { dispatch, hallData } = useRecommendHall();
  const [types, setTypes] = useState(
    hallData.weddingType === "상관없음"
      ? ["분리", "동시"]
      : hallData.weddingType === ""
        ? []
        : [hallData.weddingType],
  );

  useEffect(() => {
    setValidate(types.length > 0);
  }, [hallData.weddingType, types]);

  const goNext = () => {
    const type = types.length === 2 ? "상관없음" : types[0];
    dispatch(setWeddingType({ type: type }));
    navigate("/recommend/hall/region");
  };

  return (
    <div className="recommend-hall-page recommend-hall-selection">
      <CustomHeader goBack={() => navigate("/recommend/hall/style")} close={() => setShowStopModal(true)} />
      <StopRecommend showStopModal={showStopModal} setShowStopModal={setShowStopModal} />
      <div className="recommend-hall-page-body">
        <PageTitle
          title={`선호하는 예식 형태를
모두 선택해 주세요.`}
          type=""
        />
        <div className="recommend-hall-grid recommend-hall-grid--cols-2">
          {hallTypes.map((type) => (
            <ImageSelectableCard
              key={`style-item-${type.title}`}
              src={type.src}
              checked={types.indexOf(type.title) > -1}
              onClick={() => {
                if (types.includes(type.title)) {
                  setTypes((prev) => prev.filter((t) => t !== type.title));
                } else {
                  setTypes((prev) => [...prev, type.title]);
                }
              }}
            />
          ))}
        </div>
      </div>
      <div className="recommend-hall-page-footer">
        <button
          onClick={goNext}
          className={`btn btn-giant btn-red500 btn-full ${!validate ? "btn-disabled" : ""}`}
          disabled={!validate}
        >
          다음
        </button>
      </div>
    </div>
  );
};

export default Type;
